/**
 * @see https://stackoverflow.com/a/71115598
 * @param object
 */
export default function sizeOf( object : any ) : number {
    //const startTime = performance.now();
    const objectList = [];
    const stack : any[] = [ object ];
    let bytes : number = 0;
    while ( stack.length ) {
        const value = stack.pop();
        if ( value == null ) {
            bytes += 4;
        }
        else if ( typeof value === 'boolean' ) {
            bytes += 4;
        }
        else if ( typeof value === 'string' ) {
            bytes += value.length * 2;
        }
        else if ( typeof value === 'number' ) {
            bytes += 8;
        }
        else if ( typeof value === 'object' && objectList.indexOf( value ) === -1 ) {
            objectList.push( value );
            if ( typeof value.byteLength === 'number' ) {
                bytes += value.byteLength;
            }
            else if ( value[ Symbol.iterator ] ) {
                // eslint-disable-next-line no-restricted-syntax
                for ( const v of value ) {
                    stack.push( v );
                }
            }
            else {
                for ( const k in value ) {
                    bytes += ( k as string ).length * 2;
                    stack.push( value[ k ] );
                }
            }
        }
    }
    //console.log( `sizeOf - ${Math.round( 1000 * ( performance.now() - startTime ) ) / 1000} ms`.asLogLine( 100 ) );
    return bytes;
}
